// ImageSection.js
import React from 'react';

function ImageSection({ imageUrl, imageSectionStyle, imageStyle, title }) {
  return (
    <div className={`${imageSectionStyle}`}>
    <img
      className={imageStyle}
      src={imageUrl}
      alt={title}
    />
  </div>
  );
}

export default ImageSection;
